<template>
  <v-card
    class="pa-5 author-v-card"
  >
    <v-container>
      <v-layout wrap row class="mb-4">
        <v-flex xs8>
          <h2 class="mb-4">NEMENCIO ALMARE NICODEMUS JR., MD</h2>
        </v-flex>
      </v-layout>
      <v-layout wrap row>
        <v-flex xs12 md4>
          <img
            src="/static/img/dr_nicodemus_2016.jpg"
            width="300"
            class="image-author"
          />
        </v-flex>
        <v-flex xs12 md8>
          <div>
            <p class="subheading font-italic"> 
              <i class="purple--text">Professor, University of the Philippines &mdash; College of Medicine</i>
            </p>
            <p class="subheading">
              Dr. Nemencio Nicodemus Jr. obtained his degree of Doctor of Medicine at the University of the Philippines-College of Medicine. He subsequently completed his residency training in Internal Medicine and fellowship training in Endocrinology, Diabetes and Metabolism at the Philippine General Hospital. Subsequently, he went to the Mayo Clinic in Rochester, Minnesota as part of the Visiting Clinician Program.
            </p>
            <p class="subheading">
              He is a Professor at the University of the Philippines-College of Medicine, Department of Biochemistry & Molecular Biology. He is also a Clinical Professor at the Department of Medicine of the Philippine General Hospital, Division of Endocrinology, Diabetes & Metabolism.
            </p>
            <p class="subheading">
              He is a Council Member of the Asia & Oceania Thyroid Association (AOTA), President of the Philippine Association for The Study of Overweight and Obesity (PASOO) and Regent of the Philippine College of Physicians. 
            </p>
            <p class="subheading">
              He is a Past President of the Philippine Society of Endocrinology, Diabetes and Metabolism (PSEDM) and Philippine Thyroid Association (PTA).
            </p>
          </div>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-spacer></v-spacer>
        <v-flex xs4 text-md-right>
          <v-btn
            large
            class="accent"
            to="/dashboard"
          >
            Back
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
export default {
  data () {
    return {
      author: require('@/assets/tsl_2017.png')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/author/nicodemus.vue